import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We are going to lead a series of DDD-related workshops, including Event Storming, Example Mapping, Aggregate Canvas, BDD, Software Modeling, etc.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      